import * as Types from '../ActionTypes'
import {authInitialState} from './authInitalState'

export const projectReducer = function(state = authInitialState, action) {
    switch (action.type) {
    case Types.LOGIN_REQUEST:
        return {
            ...state,
            loading: true,
            error: authInitialState.error
        }

    case Types.LOGIN_SUCCESS:
        localStorage.setItem('token', action.payload.token)
        return {
            ...state,
            user: {
                ...action.payload
            },
            loading: false,
            error: authInitialState.error
        }

    case Types.LOGIN_ERROR_UNHANDLED:
    case Types.LOGIN_ERROR_NETWORK:
    case Types.LOGIN_ERROR_UNAUTHORIZED:
    case Types.LOGIN_ERROR_INVALID_REQUEST:
        return {
            ...state,
            user: null,
            loading: false,
            error: {
                ...state,
                type: action.type,
                details: action.payload
            }
        }

    case Types.LOGOUT_SUCCESS:
        return {
            ...state,
            user: null,
            loading: false,
            error: authInitialState.error
        }
    default: return state
    }
}

export default projectReducer
